













import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TitleSlide extends Vue {
  @Prop() enableScrollIndication!: boolean;
  @Prop() title!: string;
  @Prop() subtitle?: string;
  @Prop() backgroundImage?: string;
  @Prop() theme?: string;
  @Prop({ default: 'center' }) align?: string;
  @Prop({ default: 'full'}) layout?:string;
  @Prop({ default: 0}) padding?:string;
  @Prop({ default: 'normal'}) size?:string;
  @Prop(String) hiddenTitle!: string;
}
